import { IApplicationState } from '../../types/redux';

export const selectIsOffersFetching = (state: IApplicationState): boolean => state.calculator.isOffersFetching;
